<template>
    <div>
        <el-card style="margin-bottom:1%">
            <div class="aml">
                <div style="padding-bottom:10px;">
                    <el-checkbox @change="inspectt" v-model="form4.weizuojiancha">未做分子标志检测</el-checkbox>
                </div>
                <div style="border-bottom: 1px solid #eee;padding-bottom:10px;">
                    <span style="font-size:15px;padding-right: 20px">目前开展项目</span>
                    <el-checkbox @change="inspectc" v-model="form4.negative"
                                >全为阴性
                    </el-checkbox>
                </div>
                <el-row v-if="showAML" style="margin-top:10px;">
                    <el-col :span="24">
                        <div style="border-bottom:1px solid #eee;margin:10px 0;">AML</div>
                    </el-col>
                    <el-col :span="12">
                        <div style="border-right:1px dashed #ddd;margin-right:20px;padding-right:20px">
                            <el-row>
                                <el-col :span="5" style="font-size:14px">检查结果</el-col>
                                <el-col :span="13">fusion</el-col>
                            </el-row>
                            <draggable @end='end' group="article" :move="onRemove" v-model="amlfusion"
                                       class="amlfusion">
                                <el-row class="checktable"
                                        v-for="items in amlfusion" :key="items.value" :class="items.value"
                                        :id="'zhankai_' + items.id +'_amlfusion_weizuofusion'"
                                >
                                    <el-col :span="5">
                                        <jiancha v-model="form4[items.value]" @checkPoints="checkPoints" :keys="items.value"/>
                                    </el-col>
                                    <el-col :span="items.partner?11:9"
                                            class="fix_huoban_aml"
                                            >
                                        {{ items.label }}
                                    </el-col>
                                    <el-col :span="8" v-if="items.value == 'aml_pml_rara'">
                                        <el-checkbox-group v-model="form4.aml_pml_rara_value"
                                                           :class="$store.state.registration.form9.indexOf('form4_aml_pml_rara_value') >= 0?'container':''">
                                            <el-checkbox label="L型"></el-checkbox>
                                            <el-checkbox label="S型"></el-checkbox>
                                            <el-checkbox label="V型"></el-checkbox>
                                        </el-checkbox-group>
                                    </el-col>
                                    <el-col :span="10" v-if="items.value == 'aml_bcr_abl1'">
                                        <el-checkbox-group v-model="form4.aml_bcr_abl1_value"
                                                           :class="$store.state.registration.form9.indexOf('form4_aml_bcr_abl1_value') >= 0?'container':''">
                                            <el-checkbox label="p190"></el-checkbox>
                                            <el-checkbox label="p210"></el-checkbox>
                                            <el-checkbox label="p230"></el-checkbox>
                                        </el-checkbox-group>
                                    </el-col>
                                    <el-col :span="10" v-if="items.partner">
                                        <el-input placeholder="请输入内容"
                                                  :class="$store.state.registration.form9.indexOf('form4_' + items.partner) >= 0?'container':''"
                                                  v-model="form4[items.partner]">
                                            <template slot="prepend">伙伴基因</template>
                                        </el-input>
                                    </el-col>
                                </el-row>
                            </draggable>
                        </div>
                    </el-col>
                    <el-col :span="7">
                        <el-row>
                            <el-col :span="7" style="font-size:14px">检查结果</el-col>
                            <el-col :span="10">mutation</el-col>
                        </el-row>
                        <draggable @end='end' :move="onRemove" group="article" v-model="amlmutation"
                                   class="amlmutation">
                            <el-row class="checktable" v-for="items in amlmutation" :class="items.value"
                                    :key="items.value" :id="'zhankai_' + items.id +'_amlmutation_weizuomutation'">
                                <el-col :span="7">
                                    <jiancha v-model="form4[items.value]"
                                             @checkPoints="checkPoints" :keys="items.value"/>
                                </el-col>
                                <el-tooltip class="item" placement="top" :tabindex='-1'
                                            v-if="items.content"
                                >
                                    <div slot="content">
                                        {{ items.content }}
                                    </div>
                                    <el-col :span="8"
                                            >
                                        {{ items.label }}
                                    </el-col>
                                </el-tooltip>
                                <el-col :span="8" v-else
                                        >
                                    {{ items.label }}
                                </el-col>
                                <el-col :span="7" v-if="items.partner">
                                    <el-input placeholder="请输入内容"
                                              :class="$store.state.registration.form9.indexOf('form4_' + items.partner) >= 0?'container':''"
                                              v-model="form4[items.partner]"
                                    >
                                        <template slot="prepend">位点</template>
                                    </el-input>
                                </el-col>
                                <el-tooltip class="item" placement="top" :tabindex='-1'
                                            v-if="items.value == 'aml_flt3_itd'"
                                >
                                    <div slot="content">
                                        FLT3-ITD突变等位基因比率（allele ratio, AR）的测算采用GeneScan方法，<br/>
                                        High和Low是指FLT3-ITD等位基因比率的半定量评估，cutoff值为0.5，<br/>
                                        High是指高等位基因比率（> 0.5），Low是指低等位基因比率（&lt;0.5）。
                                    </div>
                                    <el-col :span="24">
                                        <el-row>
                                            <el-col :span="24">
                                                <el-checkbox @change="amlHighlow('High')"
                                                             :class="$store.state.registration.form9.indexOf('form4_aml_flt3_itd_high') >= 0?'container':''"
                                                             v-model='form4.aml_flt3_itd_high' label="High">High
                                                </el-checkbox>
                                                <el-checkbox @change="amlHighlow('Low')"
                                                             :class="$store.state.registration.form9.indexOf('form4_aml_flt3_itd_low') >= 0?'container':''"
                                                             v-model='form4.aml_flt3_itd_low' label="Low">Low
                                                </el-checkbox>
                                                <small style="white-space:nowrap;padding-left: 10px">*采用GeneScan方法,cutoff=0.5</small>
                                            </el-col>
<!--                                            <el-col :span="13">-->
<!--                                            </el-col>-->
                                        </el-row>
                                    </el-col>
                                </el-tooltip>
                            </el-row>
                        </draggable>
                    </el-col>
                    <el-col :span="5">
                        <el-row>
                            <el-col :span="8" style="font-size:14px">检查结果</el-col>
                            <el-col :span="10">mutation</el-col>
                        </el-row>
                        <draggable @end='end' :move="onRemove" group="article" v-model="amlmutationn"
                                   class="amlmutationn">
                            <el-row class="checktable" v-for="items in amlmutationn" :class="items.value"
                                    :key="items.value" :id="'zhankai_' + items.id +'_amlmutationn_weizuomutation'">
                                <el-col :span="8">
                                    <jiancha v-model="form4[items.value]"
                                             @checkPoints="checkPoints" :keys="items.value"/>
                                </el-col>
                                <el-col :span="7">
                                    {{ items.label }}
                                </el-col>
                                <el-col :span="9" v-if="items.partner">
                                    <el-input placeholder="请输入内容"
                                              :class="$store.state.registration.form9.indexOf('form4_' + items.partner) >= 0?'container':''"
                                              v-model="form4[items.partner]"
                                    >
                                        <template slot="prepend">位点</template>
                                    </el-input>
                                </el-col>
                            </el-row>
                        </draggable>
                    </el-col>
                </el-row>
                <div class="b-all" v-if="showALL && showBALL">
                    <el-row>
                        <el-col :span="24">
                            <div style="border-bottom:1px solid #eee;margin:10px 0;">B-ALL</div>
                        </el-col>
                        <el-col :span="14">
                            <div style="border-right:1px dashed #ddd;margin-right:20px;padding-right:20px">
                                <el-row>
                                    <el-col :span="4" style="font-size:14px">检查结果</el-col>
                                    <el-col :span="10">fusion</el-col>
                                </el-row>
                                <draggable @end='end' :move="onRemove" group="article" v-model="ballfusion"
                                           class="ballfusion">
                                    <el-row class="checktable" v-for="items in ballfusion"
                                            :class="items.value" :key="items.value"
                                            :id="'zhankai_' + items.id +'_ballfusion_weizuofusion'"
                                    >
                                        <el-col :span="4">
                                            <jiancha v-model="form4[items.value]"
                                                     @checkPoints="checkPoints" :keys="items.value"/>
                                        </el-col>
                                        <el-tooltip class="item" placement="top" :tabindex='-1'
                                                    v-if="items.value=='ball_ph_like'"
                                        >
                                            <div slot="content">
                                                Ph-like指基因表达谱与Ph+ ALL相似的一类急性淋巴细胞白血病，<br/>
                                                常合并IKZF1基因等淋巴系转录调控因子基因异常，<br/>
                                                并且上述基因异常与患者的不良预后相关。
                                            </div>
                                            <el-col :span="10">
                                                Ph-like
                                            </el-col>
                                        </el-tooltip>
                                        <el-col :span="10" v-else>
                                            {{ items.label }}
                                        </el-col>
                                        <el-col :span="10" v-if="items.partner">
                                            <el-input placeholder="请输入内容"
                                                      :class="$store.state.registration.form9.indexOf('form4_' + items.partner) >= 0?'container':''"
                                                      v-model="form4[items.partner]">
                                                <template v-if="items.value !='ball_ph_like'" slot="prepend">伙伴基因
                                                </template>
                                                <template v-else slot="prepend">受累基因</template>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                </draggable>
                            </div>
                        </el-col>
                        <el-col :span="10">
                            <el-row>
                                <el-col :span="5" style="font-size:14px">检查结果</el-col>
                                <el-col :span="10">mutation</el-col>
                            </el-row>
                            <draggable @end='end' :move="onRemove" group="article" v-model="ballmutation"
                                       class="ballmutation">
                                <el-row class="checktable"
                                        :id="'zhankai_' + items.id +'_ballmutation_weizuomutation'"
                                        v-for="items in ballmutation" :class="items.value"
                                        :key="items.value"
                                >
                                    <el-col :span="5">
                                        <jiancha v-model="form4[items.value]"
                                                 @checkPoints="checkPoints" :keys="items.value"/>
                                    </el-col>
                                    <el-col :span="10">
                                        {{ items.label }}
                                    </el-col>
                                </el-row>
                            </draggable>
                        </el-col>
                    </el-row>
                </div>
                <div class="t-all" v-if="showALL && showTALL">
                    <el-row>
                        <el-col :span="24">
                            <div style="border-bottom:1px solid #eee;margin:10px 0;">T-ALL</div>
                        </el-col>
                        <el-col :span="10">
                            <div style="border-right:1px dashed #ddd;margin-right:20px;">
                                <el-row>
                                    <el-col :span="5" style="font-size:14px">检查结果</el-col>
                                    <el-col :span="10">fusion</el-col>
                                </el-row>
                                <draggable @end='end' :move="onRemove" group="article" v-model="tallfusion"
                                           class="tallfusion">
                                    <el-row class="checktable" v-for="items in tallfusion"
                                            :key="items.value"
                                            :class="items.value" :id="'zhankai_' + items.id +'_tallfusion_weizuofusion'"
                                    >
                                        <el-col :span="5">
                                            <jiancha v-model="form4[items.value]"
                                                     @checkPoints="checkPoints" :keys="items.value"/>
                                        </el-col>
                                        <el-col :span="8"
                                                class="fix_huoban">
                                            {{ items.label }}
                                        </el-col>
                                        <el-col :span="9" v-if="items.partner">
                                            <el-input placeholder="请输入内容"
                                                      :class="$store.state.registration.form9.indexOf('form4_' + items.partner) >= 0?'container':''"
                                                      style='width:90%'
                                                      v-model="form4[items.partner]">
                                                <template slot="prepend">伙伴基因</template>
                                            </el-input>
                                        </el-col>
                                    </el-row>
                                </draggable>
                            </div>
                        </el-col>
                        <el-col :span="8" style="border-right:1px dashed #ddd;margin-right:20px;padding-right:20px"
                                class="mutation">
                            <el-row>
                                <el-col :span="7" style="font-size:14px">检查结果</el-col>
                                <el-col :span="10">mutation</el-col>
                            </el-row>
                            <draggable @end='end' :move="onRemove" group="article" v-model="tallmutation"
                                       class="tallmutation">
                                <el-row class="checktable"
                                        v-for="items in tallmutation" :class="items.value" :key="items.value"
                                        :id="'zhankai_' + items.id +'_tallmutation_weizuomutation'"
                                >
                                    <el-col :span="7">
                                        <jiancha v-model="form4[items.value]"
                                                 @checkPoints="checkPoints" :keys="items.value"/>
                                    </el-col>
                                    <el-col :span="8">
                                        {{ items.label }}
                                    </el-col>
                                    <el-col :span="9" v-if="items.partner">
                                        <el-input placeholder="请输入内容"
                                                  :class="$store.state.registration.form9.indexOf('form4_' + items.partner) >= 0?'container':''"
                                                  style='width:90%'
                                                  v-model="form4[items.partner]"
                                        >
                                            <template slot="prepend">位点</template>
                                        </el-input>
                                    </el-col>
                                </el-row>
                            </draggable>
                        </el-col>
                        <el-col :span="5">
                            <div
                                    class="dysregulation">
                                <el-row>
                                    <el-col :span="9" style="font-size:14px">检查结果</el-col>
                                    <el-col :span="12">dysregulation</el-col>
                                </el-row>
                                <draggable @end='end' :move="onRemove" group="article" v-model="dysregulation"
                                           class="dysregulation">
                                    <el-row class="checktable" v-for="items in dysregulation"
                                            :class="items.value" :key="items.value"
                                            :id="'zhankai_' + items.id +'_dysregulation_weizuodysregulation'"
                                    >
                                        <el-col :span="9">
                                            <jiancha v-model="form4[items.value]"
                                                     @checkPoints="checkPoints" :keys="items.value"/>
                                        </el-col>
                                        <el-tooltip class="item" placement="top" :tabindex='-1'
                                        >
                                            <div slot="content">
                                                基因高表达如果采用RNA-seq方法，可通过计算RPKM值衡量基因表达水平，<br/>
                                                若患者某基因RPKM值大于平均值加2倍标准差（mean + 2SD），则该基因高表达<br/>
                                            </div>
                                            <el-col :span="12">
                                                {{ items.label }}
                                            </el-col>
                                        </el-tooltip>
                                    </el-row>
                                </draggable>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div style="border-top: 1px solid #eee;padding: 20px 0;margin-top: 10px">
                    <el-checkbox v-model="form4.qita"
                    >其他未列出（突变或融合基因）
                        <el-input v-model="form4.qita_content"
                                  :disabled="!form4.qita"
                                  :class="$store.state.registration.form9.indexOf('qita_content') >= 0?'container':''"
                                  placeholder=""></el-input>
                    </el-checkbox>
                </div>
            </div>
        </el-card>
        <el-card style="margin-bottom:1%">
            <div>
                <div style="border-bottom: 1px solid #eee;padding-bottom:10px;">
                    <span style="font-size:15px;">尚未开展项目</span>
                </div>
                <el-row>
                    <el-col :span="12">
                        <div style="border-right:1px dashed #ddd;margin-right:20px;padding-right:20px">
                            <el-row style="margin-top:10px;">
                                <el-col :span="24">
                                    <el-row>
                                        <el-col :span="5" style="font-size:14px">检查结果</el-col>
                                        <el-col :span="13">fusion</el-col>
                                    </el-row>
                                    <draggable @end='end' :move="onRemove" group="article" class="weizuofusion"
                                               v-model="form8.weizuofusion"
                                    >
                                        <el-row class="checktable"
                                                v-for="(items, index) in form8.weizuofusion" :class="items.value"
                                                :id="'weizuo_' + index + '_weizuofusion_' + items.type"
                                                :key="items.value"
                                        >
                                            <el-col :span="5">
                                                <jiancha v-model="form4[items.value]" :keys="items.value"
                                                />
                                            </el-col>
                                            <el-col :span="9"
                                                    class="fix_huoban">
                                                {{ items.label }}
                                            </el-col>
                                            <el-col :span="10" v-if="items.partner">
                                                <el-input placeholder="请输入内容" :class="$store.state.registration.form9.indexOf('form4_' + items.partner) >= 0?'container':''"
                                                          v-model="form4[items.partner]">
                                                    <template v-if="items.value !='ball_ph_like'" slot="prepend">伙伴基因
                                                    </template>
                                                    <template v-else slot="prepend">受累基因</template>
                                                </el-input>
                                            </el-col>
                                        </el-row>
                                    </draggable>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                    <el-col :span="7" class="mutation">
                        <el-row style="margin-top:20px;">
                            <el-col :span="7" style="font-size:14px">检查结果</el-col>
                            <el-col :span="13">mutation</el-col>
                        </el-row>
                        <draggable @end='end' :move="onRemove" group="article" v-model="form8.weizuomutation"
                                   class="weizuomutation">
                            <el-row class="checktable" v-for="items in form8.weizuomutation" :class="items.value"
                                    :id="'weizuo_' + items.id +'_weizuomutation_'+ items.type" :key="items.value">
                                <el-col :span="7">
                                    <jiancha v-model="form4[items.value]" :keys="items.value"
                                    />
                                </el-col>
                                <el-tooltip class="item" placement="top" :tabindex='-1'
                                            v-if="items.content"
                                >
                                    <div slot="content">
                                        {{ items.content }}
                                    </div>
                                    <el-col :span="10">
                                        {{ items.label }}
                                    </el-col>
                                </el-tooltip>
                                <el-col :span="10" v-else>
                                    {{ items.label }}
                                </el-col>
                                <el-col :span="7" v-if="items.partner">
                                    <el-input placeholder="请输入内容" :class="$store.state.registration.form9.indexOf('form4_' + items.partner) >= 0?'container':''"

                                              v-model="form4[items.partner]">
                                        <template slot="prepend">位点</template>
                                    </el-input>
                                </el-col>
                                <el-tooltip class="item" placement="top" :tabindex='-1'
                                            v-if="items.value == 'aml_flt3_itd'"
                                >
                                    <div slot="content">
                                        FLT3-ITD突变等位基因比率（allele ratio, AR）的测算采用GeneScan方法，<br/>
                                        High和Low是指FLT3-ITD等位基因比率的半定量评估，cutoff值为0.5，<br/>
                                        High是指高等位基因比率（> 0.5），Low是指低等位基因比率（&lt;0.5）。
                                    </div>
                                    <el-col :span="24">
                                        <el-row>
                                            <el-col :span="11">
                                                <el-checkbox @change="amlHighlow('High')" :class="$store.state.registration.form9.indexOf('form4_aml_flt3_itd_high') >= 0?'container':''"
                                                             v-model='form4.aml_flt3_itd_high' label="High">High
                                                </el-checkbox>
                                                <el-checkbox @change="amlHighlow('Low')" :class="$store.state.registration.form9.indexOf('form4_aml_flt3_itd_low') >= 0?'container':''"
                                                             v-model='form4.aml_flt3_itd_low' label="Low">Low
                                                </el-checkbox>
                                            </el-col>
                                            <el-col :span="13">
                                                <small style="white-space:nowrap;">*采用GeneScan方法,cutoff=0.5</small>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-tooltip>
                            </el-row>
                        </draggable>
                    </el-col>
                    <el-col :span="5"
                            class="mutation">
                        <el-row style="margin-top:20px;">
                            <el-col :span="8" style="font-size:14px">检查结果</el-col>
                            <el-col :span="15">dysregulation</el-col>
                        </el-row>
                        <draggable @end='end' :move="onRemove" group="article" class="weizuodysregulation"
                                   v-model="form8.weizuodysregulation"
                        >
                            <el-row class="checktable"
                                    v-for="(items, index) in form8.weizuodysregulation" :class="items.value"
                                    :key="items.value" :id="'weizuo_' + index + '_weizuodysregulation_dysregulation'"
                            >
                                <el-col :span="8">
                                    <jiancha v-model="form4[items.value]" :keys="items.value"
                                    />
                                </el-col>
                                <el-col :span="15"
                                        class="fix_huoban">
                                    {{ items.label }}
                                </el-col>
                            </el-row>
                        </draggable>
                    </el-col>
                </el-row>
            </div>
        </el-card>
        <el-card style="margin-bottom:1%">
            <div style="border-top: 1px solid #eee;padding-top:20px;margin-top:0px">
                <el-row>
                    <el-col :span="4" style="margin-left:inherit">
                        <el-dialog title="预览" append-to-body
                                   :visible.sync="dialogVisible"
                                   height="70%">
                            <div>
                                <img :src="imageUrl"
                                     width="100%;" :style="{transform:'rotateZ('+deg+'deg)'}">
                            </div>
                            <span slot="footer"
                                  class="dialog-footer">
                                <el-button type="info" @click="rotate">旋 转</el-button>
                                <el-button type="primary"
                                           @click="dialogVisible = false">确 定</el-button>
                            </span>
                        </el-dialog>
                        <el-form-item label=""
                                      label-width="20px"
                                      prop="fileList">
                            <el-upload class="upload-demo"
                                       ref="uploaddemo"
                                       action="/api/case/upload/"
                                       :headers="uploadHeader"
                                       :onSuccess="uploadSuccess"
                                       :on-preview="handlePreview"
                                       :on-remove="handleRemove"
                                       :before-remove="beforeRemove"
                                       :file-list="form4.baogaotupian">
                                <el-button type="primary">▲报告图片上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label-width="0px">
                            <el-button type="primary" @click="wmcode('fenzibiaozhi_baogaotupian')">▲扫二维码上传</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-card>
        <el-dialog
                title="扫二维码上传"
                :visible.sync="model"
                width="30%"
                :before-close="handleQrcode">
            <erweima id="fenzbz" ref="fenzbz"/>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleQrcode">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import jiancha from './widgets/jiancha'
    import erweima from './widgets/erweima'
    import * as table from '../../../config/cyit'
    import draggable from 'vuedraggable'

    export default {
        props: ['addedit'],
        components: {
            jiancha,
            erweima,
            draggable
        },
        data() {
            let token = localStorage.getItem('token')
            return {
                deg: 0,
                tallmutation: table.tallmutation,
                dysregulation: table.dysregulation,
                ballmutation: table.ballmutation,
                ballfusion: table.ballfusion,
                tallfusion: table.tallfusion,
                amlmutationn: table.amlmutationn,
                amlfusion: table.amlfusion,
                amlmutation: table.amlmutation,
                aml_flt3_itd_high: '',
                aml_flt3_itd_low: '',
                model: false,
                form4: this.$store.state.registration.form4,
                form8: this.$store.state.registration.form8,
                uploadHeader: {Authorization: `Bearer ${token}`},
                dialogVisible: false,
                imageUrl: '',
                aml: false,
                ball: false,
                tall: false,
                all: false
            }
        },
        computed: {
            showAML() {
                var that = this
                that.aml = false
                var temp = this.$store.state.registration.form2.zhenduanfenxing
                if (temp[0] === '急性双表型白血病' || temp[0] === '不详')
                    return true
                if (temp[0] === 'AML') {
                    // this.weizuoDuo('weizuofusion','amlfusion')
                    // this.amlMutatn()
                    // that.form8.weizuodysregulation = []
                    that.aml = true
                    return true
                }
                return false
            },
            showALL() {
                var that = this
                var temp = this.$store.state.registration.form2.zhenduanfenxing
                that.all = false
                if (temp[0] === '急性双表型白血病' || temp[0] === '不详') {
                    // this.weizuoDuoAll()
                    that.all = true
                    return true
                }
                if (temp[0] === 'ALL') {
                    that.all = true
                    return true
                }
                return false
            },
            showBALL() {
                var that = this
                var temp = this.$store.state.registration.form2.zhenduanfenxing
                that.ball = false
                if (temp[0] === '急性双表型白血病' || temp[0] === '不详')
                    return true
                if (temp.length == 2) {
                    if (temp[1] === '不能分型的ALL' || temp[1].indexOf("B细胞ALL") != -1) {
                        // that.form8.weizuodysregulation = [];
                        // this.weizuoDuo('weizuofusion','ballfusion');
                        // this.weizuoDuo('weizuomutation','ballmutation');
                        that.ball = true
                        return true
                    }
                }
                return false
            },
            showTALL() {
                var that = this
                that.tall = false
                var temp = this.$store.state.registration.form2.zhenduanfenxing
                if (temp[0] === '急性双表型白血病' || temp[0] === '不详')
                    return true
                if (temp.length == 2) {
                    if (temp[1] === '不能分型的ALL' || temp[1].indexOf("T-ALL") != -1) {
                        // this.weizuoDuo('weizuofusion','tallfusion')
                        // this.weizuoDuo('weizuomutation','tallmutation')
                        // this.weizuoDuo('weizuodysregulation','dysregulation')
                        that.tall = true
                        return true
                    }
                }
                return false
            }
        },
        methods: {
            rotate() {
                this.deg += 90;
                if (this.deg >= 360) {
                    this.deg = 0
                }
            },
            FzChange() {
                var temp = this.$store.state.registration.form2.zhenduanfenxing
                if (temp[0] === 'AML') {
                    this.weizuoDuo('weizuofusion', 'amlfusion')
                    this.amlMutatn()
                    this.form8.weizuodysregulation = []
                }
                if (temp[0] === '急性双表型白血病' || temp[0] === '不详') {
                    this.weizuoDuoAll()
                }
                if (temp.length == 2) {
                    if (temp[1] === '不能分型的ALL' || temp[1].indexOf("B细胞ALL") != -1) {
                        this.form8.weizuodysregulation = [];
                        this.weizuoDuo('weizuofusion', 'ballfusion');
                        this.weizuoDuo('weizuomutation', 'ballmutation');
                    }
                }
                if (temp.length == 2) {
                    if (temp[1] === '不能分型的ALL' || temp[1].indexOf("T-ALL") != -1) {
                        this.weizuoDuo('weizuofusion', 'tallfusion')
                        this.weizuoDuo('weizuomutation', 'tallmutation')
                        this.weizuoDuo('weizuodysregulation', 'dysregulation')
                    }
                }
            },
            init() {
                this.$store.state.registration.form8 = this.form8
            },
            Commit(fusion, weizuo) {
                var weizuofn = []
                for (var i in fusion) {
                    for (var key in table[fusion[i]]) {
                        var value = table[fusion[i]][key]['value']
                        if (this.form4[value] == '未做') {
                            weizuofn.push(table[fusion[i]][key])
                        }
                    }
                }
                this.$store.state.registration.form8[weizuo] = weizuofn
            },
            checkPoints(val) {
                if (this.form4.negative && val != '阴性') {
                    this.form4.negative = false
                }
                if (this.form4.weizuojiancha && val != '未做') {
                    this.form4.weizuojiancha = false
                }
            },
            handleQrcode() {
                this.model = false
                this.getimage('fenzibiaozhi_baogaotupian')
            },
            amlMutatn() {
                var temp = []
                temp.push.apply(temp, this.weizuoDuo('weizuomutation', 'amlmutation', 'all'))
                temp.push.apply(temp, this.weizuoDuo('weizuomutation', 'amlmutationn', 'all'))
                this.form8.weizuomutation = temp
            },
            onRemove(evt) {
                console.log(evt)
                var to = evt.to.className
                var id = evt.dragged.id
                var temp = id.split('_')
                var from = evt.from.className
                if (to == from) {
                    return true
                }
                if (temp[3] != to) {
                    return false
                }
                return true
            },
            weizuoDuoAll() {
                var temp = []
                var temp1 = []
                temp.push.apply(temp, this.weizuoDuo('weizuofusion', 'amlfusion', 'all'))
                temp1.push.apply(temp1, this.weizuoDuo('weizuomutation', 'amlmutation', 'all'))
                temp1.push.apply(temp1, this.weizuoDuo('weizuomutation', 'amlmutationn', 'all'))
                temp.push.apply(temp, this.weizuoDuo('weizuofusion', 'ballfusion', 'all'))
                temp1.push.apply(temp1, this.weizuoDuo('weizuomutation', 'ballmutation', 'all'))
                this.weizuoDuo('weizuodysregulation', 'dysregulation')
                temp.push.apply(temp, this.weizuoDuo('weizuofusion', 'tallfusion', 'all'))
                temp1.push.apply(temp1, this.weizuoDuo('weizuomutation', 'tallmutation', 'all'))
                this.form8.weizuomutation = temp1
                this.form8.weizuofusion = temp
            },
            weizuoDuo(weizuofusion, amlfusion, all) {
                var lt = this.$store.state.registration.form8[weizuofusion]
                var zhankai = []
                var weizuo = []
                // let pk = this.$route.params.pk
                for (var i in table[amlfusion]) {
                    // if(!pk){
                    var flag = 0
                    for (var j in lt) {
                        if (lt[j]['value'] == table[amlfusion][i]['value']) {
                            flag = 1
                        }
                    }
                    if (flag == 1) {
                        weizuo.push(table[amlfusion][i])
                        this.form4[table[amlfusion][i]['value']] = '未做'
                    } else {
                        zhankai.push(table[amlfusion][i])
                    }
                }
                this[amlfusion] = zhankai
                if (all) {
                    return weizuo
                } else {
                    this.form8[weizuofusion] = weizuo
                }
            },
            amlHighlow(v) {
                if (v == 'High') {
                    this.form4.aml_flt3_itd_low = ''
                } else {
                    this.form4.aml_flt3_itd_high = ''
                }
            },
            end(evt) {
                var form = evt.from.className
                var classname = evt.clone.className.split(' ')[2]
                var to = evt.to.className
                var id = evt.clone.id
                var temp = id.split('_')
                if (to != form) {
                    if (temp[0] == 'weizuo') {
                        this.form4[classname] = ''
                    } else {
                        this.form4[classname] = '未做'
                    }
                }
            },
            quchong(data) {
                var b = []
                var tem = data.concat(this.form4.baogaotupian);
                var len = tem.length;
                var i = 0;
                var arr = [];
                for (; i < len; i++) {
                    var t = tem[i];
                    if (arr.indexOf(t['id']) == -1) {
                        arr.push(t['id']);
                        b.push(t);
                    }

                }
                return b
            },
            getimage(value) {
                this.$http.get(`/case/image/list/?filed=${value}&uid=${this.$store.state.registration.form1.uuid}`)
                    .then(resp => {
                        this.form4.baogaotupian = this.quchong(resp.data.data)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            S4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            },
            guid() {
                var that = this
                return (that.S4() + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + "-" + that.S4() + that.S4() + that.S4());
            },
            wmcode(value) {
                var that = this
                that.model = true
                if (!that.$store.state.registration.form1.uuid) {
                    that.$store.state.registration.form1.uuid = that.guid()
                }
                if (that.$store.state.registration.form1.uuid) {
                    var url = window.location.href.split('#')[0] + 'case/uploadsredoce/?field='
                    url = url + value + '&uuid=' + that.$store.state.registration.form1.uuid + "&token=" + localStorage.getItem('token')
                    that.$nextTick(() => {
                        this.$refs.fenzbz.useqrcode(url)
                    })
                } else {
                    that.$message({
                        message: '请先暂存数据，再刷新页面',
                        type: 'warning'
                    })
                }
            },
            inspectt(v) {
                if (v) {
                    v = '未做'
                } else {
                    v = ''
                }
                this.form4.negative = false
                this.fuzhi(v)
            },
            inspectc(v) {
                if (v) {
                    v = '阴性'
                } else {
                    v = ''
                }
                this.form4.weizuojiancha = false
                this.fuzhi(v)
            },
            fuzhi(v) {
                var temp = 0
                var lt = this.form8.weizuofusion.concat(this.form8.weizuodysregulation, this.form8.weizuomutation)
                var data = []
                if (this.aml) {
                    data = table.amlfusion.concat(table.amlmutationn, table.amlmutation)
                } else if (this.ball && this.all) {
                    data = table.ballfusion.concat(table.ballmutation)
                } else if (this.tall && this.all) {
                    data = table.tallfusion.concat(table.tallmutation, table.dysregulation)
                } else {
                    data = table.fenzi
                    temp = 1
                }
                for (var i in data) {
                    var flag = 0
                    for (var j in lt) {
                        if (temp == 1 && lt[j]['value'] == data[i]) {
                            flag = 1
                        }
                        if (temp == 0 && lt[j]['value'] == data[i]['value']) {
                            flag = 1
                        }
                    }
                    if (flag == 0) {
                        if (temp == 1) {
                            this.form4[data[i]] = v
                        } else {
                            this.form4[data[i]['value']] = v
                        }
                    }
                }
            },
            handlePreview(e) {
                var name = e.url.split('.').pop()
                if (name == "pdf") {
                    window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
                } else if (name == "png" || name == "jpeg" || name == "bmp" || name == "jpg") {
                    // this.dialogVisible = true
                    // this.imageUrl = e.url
                    window.open(window.location.href.split('#')[0] + e.url.slice(1), "_blank");
                } else {
                    window.location = window.location.href.split('#')[0] + e.url.slice(1)
                }
            },
            handleRemove(file, fileList) {
                this.$store.state.registration.form4.baogaotupian = fileList
                this.$store.dispatch({
                    type: 'delImage',
                    pk: file.id,

                }).then(resp => {
                    if (resp.data.code == 1) {
                        this.$message({message: '删除成功！', type: 'success'})
                    } else if (resp.data.code == -1) {
                        this.$message({message: resp.data.errors, type: 'error'})
                    }
                });
            },
            uploadSuccess(response, file) {
                this.$store.state.registration.form4.baogaotupian.push(file.response)
            }
        },
        mounted() {
            var that = this
            // this.FzChange()
            if (this.addedit == 0) {
                this.$store.state.registration.form4.baogaotupian = []
                this.$refs.uploaddemo.clearFiles();
            }
            this.$bus.$on('shareText', function () {
                that.FzChange()
            })
        }
    };
</script>


<style scoped>
    .caption {
        text-align: center;
    }

    .checktable {
        color: #303133;
        font-size: 14px;
        line-height: 30px;
    }

    .checktable /deep/ .el-input-group__prepend {
        padding: 5px;
        background-color: #f7f7f8;
    }

    .checksub {
        float: right;
        padding-right: 10px;
    }

    .checksub /deep/ .el-checkbox__label {
        display: none;
        display: inline-block;
        font-size: 12px;
    }

    /deep/ .el-checkbox {
        margin-right: 10px
    }

    /deep/ .el-form-item__content {
        margin-left: 0px;
    }

    .dysregulation .el-col-6,
    .mutation .el-col-6,
    .el-col-2 {
        width: 40px;
        font-size: 14px;
        text-align: center;
    }

    .fix_huoban {
        width: 150px;
    }

    .fix_huoban_aml {
        width: 197px;
    }

    .container /deep/ .el-input__inner {
        color: red;
    }

    .container /deep/ .el-checkbox__inner {
        border: 1px solid red;
    }
</style>
